import Utility from '../Utility/Utility';
import 'bootstrap/dist/css/bootstrap.min.css';

let Utl = new Utility();
let language = Utl.getCookie("appLang");

const busInstr      = ( language === "en" ? "* Fields marked with asteriks are required" : "Campos marcados con asteriscos son requeridos" );
const busName       = ( language === "en" ? "Business name" : "Nombre del negocio" );
const busAddr1      = ( language === "en" ? "Address Line 1" : "Dirección Línea 1" );
const busAddr2      = ( language === "en" ? "Address Line 2" : "Dirección Línea 2" );
const busCity       = ( language === "en" ? "City" : "Ciudad" );
const busState      = ( language === "en" ? "State" : "Estado" );
const busZip        = ( language === "en" ? "Zip" : "Código postal" );
const busPhone      = ( language === "en" ? "Phone" : "Teléfono" );
const busFood       = ( language === "en" ? "Food type" : "Tipo de comida" );
const busLogo       = ( language === "en" ? "Business logo" : "Logo del negocio" );
const busWeb        = ( language === "en" ? "Internet address" : "Dirección de Internet" );
const busUpld       = ( language === "en" ? "Upload" : "Subir" );
const busDesc       = ( language === "en" ? "Business description" : "Descripción del negocio" );
const busEng        = ( language === "en" ? "English" : "Inglés" );
const busSpa        = ( language === "en" ? "Spanish" : "Español" );
const busHours      = ( language === "en" ? "Business hours" : "Horario" );
const busFrom       = ( language === "en" ? "From"  : "De" );
const busTo         = ( language === "en" ? "To"    : "A" );
const busStatus     = ( language === "en" ? "Account status" : "Estado de cuenta" );
const acctActive    = ( language === "en" ? "Active" : "Activa" );
const acctInact     = ( language === "en" ? "Inactive" : "Inactiva" );
const acctSusp      = ( language === "en" ? "Suspended" : "Suspendida" );
const acctUnder     = ( language === "en" ? "Under construction" : "En construcción" );

const busMon        = ( language === "en" ? "Monday"    : "Lunes" );
const busTue        = ( language === "en" ? "Tuesday"   : "Martes" );
const busWed        = ( language === "en" ? "Wednesday" : "Miércoles" );
const busThu        = ( language === "en" ? "Thursday"  : "Jueves" );
const busFri        = ( language === "en" ? "Friday"    : "Viernes" );
const busSat        = ( language === "en" ? "Saturday"  : "Sábado" );
const busSun        = ( language === "en" ? "Sunday"    : "Domingo" );

export const AccountProfile = 
    `
                <input type="hidden" name="MAX_FILE_SIZE" value="5000000" />
                <div class='row'>
                    <div class='col-md-8 col-xs-12'>
                        <div class='row'>
                            <div class='col-lg-12 text-start'>
                                <span class='me-2'><strong>*</strong></span> `+busInstr+`
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busName+`
                                    </div>
                                    <div class='col-lg-8 text-start mt-3'>
                                        <input type='hidden' name='cus_account' id='cus_account' />
                                        <input type='text' name='cus_bus_name' id='cus_bus_name' class='form-control' maxLength="64" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busAddr1+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_address' id='cus_bus_address' class='form-control' maxLength="64" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        `+busAddr2+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_address_2' id='cus_bus_address_2' class='form-control' maxLength="32" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busCity+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_city' id='cus_bus_city' class='form-control' maxLength="32" required />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busState+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <select name='cus_bus_state' id='cus_bus_state' class='form-control'></select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busZip+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_zip' id='cus_bus_zip' class='form-control' maxLength="10" required />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busPhone+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_phone' id='cus_bus_phone' class='form-control' placeholder="(999)-999-9999" maxLength="10" required />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        <span class='me-2'><strong>*</strong></span> `+busFood+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <select name='cus_bus_food_type' id='cus_bus_food_type' class='form-control'></select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="appBusinessLogo" class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        `+busLogo+`
                                    </div>
                                    <div class='col-lg-8 text-start d-inline'>
                                        
                                        <input class="d-none" id="cus_logo_upload" name="cus_logo_upload" maxLength='32' type="file" accept="image/png, image/jpeg" />
                                        <input type="hidden" id="cus_logo_saved" />
                                        <input type='text' name='cus_logo' id='cus_logo' maxLength='32' class='form-control w-75 d-inline' readOnly />
                                        <button type="button" id="appSelectLogo" class='btn btn-primary'>`+busUpld+`</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-lg-12'>
                                <div class='row form-group'>
                                    <div class='col-lg-4 text-end app-label-input'>
                                        `+busWeb+`
                                    </div>
                                    <div class='col-lg-8 text-start'>
                                        <input type='text' name='cus_bus_web_address' id='cus_bus_web_address' maxLength='64' class='form-control' />
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>



                    <div id='appBusinessHours' class='col-md-4 col-xs-12'>
                        <div class='row'>
                            <div class='col-md-12 text-center'>
                                <h4 class='text-decoration-underline'>`+busHours+`</h4>
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-md-4 col-sm-4'>
                            </div>
                            <div class='col-md-4 col-sm-4 text-center'>
                                <h5>`+busFrom+`</h5>
                            </div>
                            <div class='col-md-4 col-sm-4 text-center'>
                                <h5>`+busTo+`</h5>
                            </div>
                        </div>
                            
                        <div class='row'>
                            <div class='col-md-4 col-sm-4'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_mon" name="cus_bus_hours_mon" />
                                    <input class="form-check-input" id="bus_hours_mon" name="bus_hours_mon" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_mon">
                                        `+busMon+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 text-center'>
                                <span id='mon_time_from_label'></span>
                                <input type='time' class='d-none' name='mon_time_from' id='mon_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 text-center'>
                                <span id='mon_time_to_label'></span>
                                <input type='time' class='d-none' name='mon_time_to' id='mon_time_to' disabled />
                            </div>
                        </div>
                            
                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_tue" name="cus_bus_hours_tue" />
                                    <input class="form-check-input" id="bus_hours_tue" name="bus_hours_tue" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_tue">
                                        `+busTue+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='tue_time_from_label'></span>
                                <input type='time' class='d-none' name='tue_time_from' id='tue_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='tue_time_to_label'></span>
                                <input type='time' class='d-none' name='tue_time_to' id='tue_time_to' disabled />
                            </div>
                        </div>

                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_wed" name="cus_bus_hours_wed" />
                                    <input class="form-check-input" id="bus_hours_wed" name="bus_hours_wed" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_wed">
                                        `+busWed+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='wed_time_from_label'></span>
                                <input type='time' class='d-none' name='wed_time_from' id='wed_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='wed_time_to_label'></span>
                                <input type='time' class='d-none' name='wed_time_to' id='wed_time_to' disabled />
                            </div>
                        </div>

                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_thu" name="cus_bus_hours_thu" />
                                    <input class="form-check-input" id="bus_hours_thu" name="bus_hours_thu" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_thu">
                                        `+busThu+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='thu_time_from_label'></span>
                                <input type='time' class='d-none' name='thu_time_from' id='thu_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='thu_time_to_label'></span>
                                <input type='time' class='d-none' name='thu_time_to' id='thu_time_to' disabled />
                            </div>
                        </div>

                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_fri" name="cus_bus_hours_fri" />
                                    <input class="form-check-input" id="bus_hours_fri" name="bus_hours_fri" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_fri">
                                        `+busFri+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='fri_time_from_label'></span>
                                <input type='time' class='d-none' name='fri_time_from' id='fri_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='fri_time_to_label'></span>
                                <input type='time' class='d-none' name='fri_time_to' id='fri_time_to' disabled />
                            </div>
                        </div>

                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_sat" name="cus_bus_hours_sat" />
                                    <input class="form-check-input" id="bus_hours_sat" name="bus_hours_sat" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_sat">
                                        `+busSat+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='sat_time_from_label'></span>
                                <input type='time' class='d-none' name='sat_time_from' id='sat_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='sat_time_to_label'></span>
                                <input type='time' class='d-none' name='sat_time_to' id='sat_time_to' disabled />
                            </div>
                        </div>

                        <div class='row'>
                            <div class='col-md-4 col-sm-4 mt-2'>
                                <div class="form-check">
                                    <input type="hidden" id="cus_bus_hours_sun" name="cus_bus_hours_sun" />
                                    <input class="form-check-input" id="bus_hours_sun" name="bus_hours_sun" type="checkbox">
                                    <label class="form-check-label" for="bus_hours_sun">
                                        `+busSun+`
                                    </label>
                                </div>
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='sun_time_from_label'></span>
                                <input type='time' class='d-none' name='sun_time_from' id='sun_time_from' disabled />
                            </div>
                            <div class='col-md-4 col-sm-4 mt-2 text-center'>
                                <span id='sun_time_to_label'></span>
                                <input type='time' class='d-none' name='sun_time_to' id='sun_time_to' disabled />
                            </div>
                        </div>

                        <div class='row mt-2'>
                            <div class='col-md-12 text-center'>
                                <h4 class='text-decoration-underline'>`+busStatus+`</h4>
                            </div>
                        </div>

                        <div class='row mt-1'>
                            <div class='col-md-12'>
                                <div class="form-check acct-status-pointer">
                                    <input type="hidden" name="cus_acct_status" id="cus_acct_status" value="U" />
                                    <input class="form-check-input" type="radio" name="acctStatus" id="acctStatusActive">
                                    <label class="form-check-label" for="acctStatusActive">
                                        `+acctActive+`
                                    </label>
                                </div>
                                <div class="form-check acct-status-pointer">
                                    <input class="form-check-input" type="radio" name="acctStatus" id="acctStatusInactive">
                                    <label class="form-check-label" for="acctStatusInactive">
                                        `+acctInact+`
                                    </label>
                                </div>
                                <div class="form-check acct-status-pointer">
                                    <input class="form-check-input" type="radio" name="acctStatus" id="acctStatusSuspended">
                                    <label class="form-check-label" for="acctStatusSuspended">
                                        `+acctSusp+`
                                    </label>
                                </div>
                                <div class="form-check acct-status-pointer">
                                    <input class="form-check-input" type="radio" name="acctStatus" id="acctStatusUnder" checked>
                                    <label class="form-check-label" for="acctStatusUnder">
                                        `+acctUnder+`
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class='row mt-2'>
                    <div class='col-lg-12 text-center'>
                        <h4 class='mb-0'>`+busDesc+`</h4>
                    </div>
                </div>

                <div class='row mt-1'>
                    <div class='col-lg-6'>
                        <div class='row'>
                            <div class='col-lg-12 text-center'>
                                <h6>`+busEng+`</h6>
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-lg-12'>
                                <textarea id="cus_bus_desc_en" name="cus_bus_desc_en" autocorrect="on" maxlength="2048" rows="5" cols="33"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class='col-lg-6'>
                        <div class='row'>
                            <div class='col-lg-12 text-center'>
                                <h6>`+busSpa+`</h6>
                            </div>
                        </div>
                        <div class='row'>
                            <div class='col-lg-12'>
                                <textarea id="cus_bus_desc_es" name="cus_bus_desc_es" autocorrect="on" maxlength="2048" rows="5"></textarea>
                            </div>
                        </div>
                    </div>
                </div>


            
    `;